import React, { useState } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/core';
import { map } from 'lodash';
import { questions } from './Questions';
import { Grid, GridItem } from '../../components/common';
import { pxToRem } from '../../utils/dimensionConverter';

export const FaqsContent = () => {
  const [active, setActive] = useState(1);

  const renderItemList = (list) => {
    return map(questions[list], (item, idx) => {
      return (
        <AccordionItem className="slide-header" key={idx}>
          <AccordionHeader>
            <div className="slide-title">
              <span className="slide-bullet">{idx + 1}.</span>
              <span>{item.question}</span>
            </div>
            <AccordionIcon />
          </AccordionHeader>
          <AccordionPanel pb={pxToRem(4)}>
            <div className="slide-answer push--bottom soft-half--bottom">
              <p dangerouslySetInnerHTML={{ __html: item.answer }}></p>
            </div>
          </AccordionPanel>
        </AccordionItem>
      );
    });
  };

  const menuNav = [
    { id: 1, title: 'Account', url: 'account' },
    { id: 2, title: 'System Operational', url: 'systemOperational' },
    { id: 3, title: 'General', url: 'general' },
    { id: 4, title: 'Service Request', url: 'serviceRequest' },
    { id: 5, title: 'Clinical Document', url: 'clinicalDocument' },
    { id: 6, title: 'Support', url: 'support' }
  ];

  return (
    <div className='push--top'>
      <Grid className='push--top'>
        <GridItem xsmall={12} small={4}>
          <nav className="push--top section-nav">
            <h5 className='flush--bottom'>Topics</h5>
            <ul className="section-nav__list">
              {map(menuNav, ({ title, url, id }) => {
                return (
                  <li
                    onClick={() => setActive(id)}
                    className={`section-nav__item ${
                      id === active && "active"
                    }`}
                    key={id}
                  >
                    <a href={`#${url}`}>{title}</a>
                  </li>
                );
              })}
            </ul>
          </nav>
        </GridItem>
        <GridItem xsmall={12} small={8}>
          
          {map(menuNav, ({ title, url, id }) => {
            return (
              <div id={url} key={url}>
                <h2 className="h3 push--top">{title}</h2>
                <Accordion defaultIndex={[{id}]} allowMultiple>
                  {renderItemList(url)}
                </Accordion>
              </div>
            );
          })}
        </GridItem>
      </Grid>
    </div>
  );
};

export default FaqsContent;
